import { Component } from '@angular/core';

interface BomItem {
  id: number;
  name: string;
  quantity: number;
}

@Component({
  selector: 'app-bom-list',
  templateUrl: './bom-list.component.html'
})
export class BomListComponent {
  bomList: BomItem[] = [
    { id: 1, name: 'Steel Rod', quantity: 20 },
    { id: 2, name: 'Copper Wire', quantity: 50 },
    { id: 3, name: 'Plastic Sheet', quantity: 100 },
  ];

  selectedItem: BomItem | null = null;

  editItem(item: BomItem) {
    this.selectedItem = { ...item }; // clone object
  }

  updateItem() {
    if (this.selectedItem) {
      const index = this.bomList.findIndex(b => b.id === this.selectedItem!.id);
      if (index !== -1) {
        this.bomList[index] = { ...this.selectedItem };
      }
      this.selectedItem = null;
    }
  }

  cancelEdit() {
    this.selectedItem = null;
  }

  deleteItem(item: BomItem) {
    this.bomList = this.bomList.filter(b => b.id !== item.id);
  }
}
